import { SchemaType } from "@/lib/schema/types";

interface StructuredDataProps {
  schemas: SchemaType[];
}

export function StructuredData({ schemas }: StructuredDataProps) {
  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema, null, 2),
          }}
        />
      ))}
    </>
  );
}
